export const defaultState = {
  error: null,
};

export const onError = (state, { error }) => ({
  ...state,
  error,
});

export const clearError = state => ({
  ...state,
  error: null,
});
